import { render, staticRenderFns } from "./imageMarkWrapper.vue?vue&type=template&id=23b4c6a8&scoped=true&"
import script from "./imageMarkWrapper.vue?vue&type=script&lang=js&"
export * from "./imageMarkWrapper.vue?vue&type=script&lang=js&"
import style0 from "./imageMarkWrapper.vue?vue&type=style&index=0&id=23b4c6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b4c6a8",
  null
  
)

export default component.exports